<template>
  <div class="login">

    <main role="main" class="container">  
      <div class="text-center">
        <form class="form-signin" @submit.prevent="login({ username, password })">
          <img alt="Vue logo" src="logo.svg">
          <h5 class="m-3 dark-gray">Wi-Fi Density</h5>
          <h3 class="mb-3 font-weight-normal">Please sign in</h3>
          <label for="inputEmail" class="sr-only">Username</label>
          <input type="email" id="inputEmail" class="form-control" placeholder="Username" required autofocus v-model="username" @input="resetMessage">
          <label for="inputPassword" class="sr-only">Password</label>
          <input type="password" id="inputPassword" class="form-control" placeholder="Password" required v-model="password" @input="resetMessage" autocomplete="on">
          <div id="error" class="mb-2">{{message}}&nbsp;</div>
          <!-- <div class="checkbox mb-3">
            <label>
              <input type="checkbox" value="remember-me"> Remember me
            </label>
          </div> -->
          <b-btn class="btn btn-lg btn-primary btn-block" variant="dark" type="submit">Sign in</b-btn>
          <p class="mt-5 mb-3 text-muted">{{COPYRIGHT}}</p>
        </form>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'Login',
  methods: {
    login() {
      axios.post(
        process.env.VUE_APP_API_URL + "/users/login", 
        {
          username: this.username, 
          password: this.password
        }
      ).then(result => {
        if (result.data.error) {
          this.message = result.data.error + ' Try again.';
        } else {
          const token = result.data; 
          localStorage.setItem('density.token', token); 
          // - why do we need this at all?
          axios.post(
            process.env.VUE_APP_API_URL + '/users/get',
            {},
            { headers: { authorization: token }}
          // ----------------------------
          ).then(result => {
            this.$store.commit("user", result.data); 
            this.$router.push("/maps");
          });
        }
      });
    },
    resetMessage() {
      this.message = '';
    }
  },
  data() {
    return {
      username: "",
      password: "",
      message: "",
      COPYRIGHT: process.env.VUE_APP_COPYRIGHT
    }
  },
  mounted() {
    //commented this out to test JWT auth
    // if (process.env.NODE_ENV !== "production") {
    //   let allowed = JSON.parse(process.env.VUE_APP_ALLOWED_USER);
    //   axios.post(process.env.VUE_APP_API_URL + '/users/login', allowed).then(response => {
    //     if (response.data) {
    //       this.$store.commit("user", response.data);
    //       this.$router.push("/maps");
    //     } else {
    //       this.$router.push("/about");
    //     }
    //   });
    // }
  }
}
</script>

<style scoped>
html,
body {
  height: 100%;
}

body {
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  padding-top: 40px;
  padding-bottom: 40px;
  background-color: #f5f5f5;
}

.cardinal {
    color: #990000;
}

.gold {
  color: #FFCC00
}

.dark-gray {
  color: #777777
}

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;
}
.form-signin .checkbox {
  font-weight: 400;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
.form-signin h1 {
  font-size: 6em;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
#error {
  color: red;
  font-weight: bold;
}
</style>
